import jwt from "@/common/lib/jwt";
import Config from "@/common/config";
import APP_CONST from "@/common/constants";
import { getWebSocketUrl } from "@/common/lib/utils";

const mutationTypes = {
  INIT: "websocket/init",
};

let reconnectTimeoutId = null;

const state = {
  webSocket: null,
};

const actions = {
  init({ commit, state, dispatch, rootGetters }) {
    if (state.webSocket && state.webSocket.readyState === WebSocket.OPEN)
      return;
    const url = getWebSocketUrl(Config.wsUrl, { token: jwt.getToken() });
    const webSocket = new WebSocket(url);
    handleMessage(webSocket, dispatch, rootGetters);
    commit(mutationTypes.INIT, webSocket);
  },
};

const mutations = {
  [mutationTypes.INIT](state, webSocket) {
    state.webSocket = webSocket;
  },
};

const handleMessage = (webSocket, dispatch, rootGetters) => {
  webSocket.onopen = () => {
    clearTimeout(reconnectTimeoutId);
  };
  webSocket.onclose = () => {
    reconnectTimeoutId = setTimeout(() => {
      clearTimeout(reconnectTimeoutId);
      dispatch("init");
    }, 1000);
  };
  webSocket.onmessage = event => {
    setTimeout(() => {
      const msg = JSON.parse(event.data);
      if (msg.status === false) return;
      switch (msg.type) {
        case APP_CONST.WS_EVENT_TYPES.KYBERDAO_TX_CONFIRMED: {
          if (msg.tx?.type === "approve") {
            dispatch("staking/kyber/getAllowance", null, { root: true });
          } else {
            dispatch("staking/kyber/fetchAvailableBalance", null, {
              root: true,
            });
            dispatch("staking/kyber/fetchStakedBalance", null, {
              root: true,
            });
          }
          dispatch(
            "notification/addAlertNoti",
            {
              ...msg,
              type: "transaction",
              txType: APP_CONST.EVENT_TYPE_TO_TX_TYPE[msg.type],
            },
            { root: true }
          );
          if (window.location.pathname.startsWith("/portfolio")) {
            dispatch("portfolio/fetchAUM", null, { root: true });
          }
          break;
        }
        case APP_CONST.WS_EVENT_TYPES.SMART_CONTRACT_TX_CONFIRMED: {
          if (window.location.pathname.startsWith("/portfolio")) {
            dispatch("portfolio/fetchAUM", null, { root: true });
          }
          dispatch(
            "notification/addAlertNoti",
            {
              ...msg,
              type: "transaction",
              txType: APP_CONST.EVENT_TYPE_TO_TX_TYPE[msg.type],
            },
            { root: true }
          );
          break;
        }
        case APP_CONST.WS_EVENT_TYPES.TENDERMINT_TX_CONFIRMED: {
          dispatch(
            "notification/addAlertNoti",
            {
              ...msg,
              type: "transaction",
              txType: APP_CONST.EVENT_TYPE_TO_TX_TYPE[msg.type],
            },
            { root: true }
          );
          if (window.location.pathname.startsWith("/portfolio")) {
            dispatch("portfolio/fetchAUM", null, { root: true });
          }
          if (window.location.pathname.startsWith(`/stake/${msg.tx.network}`)) {
            dispatch("staking/tendermint/fetchRequiredInfo", null, {
              root: true,
            });
            if (msg.tx.network === "terra") {
              dispatch("staking/tendermint/anchor/fetchRequiredInfo", null, {
                root: true,
              });
            }
            if (msg.tx.network === "osmosis") {
              dispatch(
                "staking/tendermint/osmosis/getAutocompoundLocks",
                null,
                { root: true }
              );
              dispatch("staking/tendermint/osmosis/getGrantStatus", null, {
                root: true,
              });
            }
          }
          break;
        }
        case APP_CONST.WS_EVENT_TYPES.ETH_STAKING_FINISHED: {
          dispatch(
            "notification/addAlertNoti",
            {
              ...msg,
              type: "transaction",
              txType: APP_CONST.EVENT_TYPE_TO_TX_TYPE[msg.type],
            },
            { root: true }
          );
          if (window.location.pathname.startsWith("/stake/skale")) {
            dispatch("staking/skale/fetchRequiredInfo", null, { root: true });
          }
          if (window.location.pathname.startsWith("/stake/thegraph")) {
            dispatch("staking/thegraph/fetchRequiredInfo", null, {
              root: true,
            });
          }
          if (window.location.pathname.startsWith("/stake/celer")) {
            dispatch("staking/celer/fetchRequiredInfo", null, { root: true });
          }
          if (window.location.pathname.startsWith("/portfolio")) {
            dispatch("portfolio/fetchAUM", null, { root: true });
          }
          break;
        }
        case APP_CONST.WS_EVENT_TYPES.NONETH_STAKING_FINISHED: {
          dispatch(
            "notification/addAlertNoti",
            {
              ...msg,
              type: "transaction",
              txType: APP_CONST.EVENT_TYPE_TO_TX_TYPE[msg.type],
            },
            { root: true }
          );
          if (window.location.pathname.startsWith("/stake/solana")) {
            dispatch("staking/solana/fetchRequiredInfo", null, { root: true });
          }
          if (window.location.pathname.startsWith("/stake/sui")) {
            dispatch("staking/sui/fetchRequiredInfo", null, { root: true });
          }
          break;
        }
        case APP_CONST.WS_EVENT_TYPES.ANNOUCEMENT: {
          dispatch(
            "notification/addAlertNoti",
            {
              ...msg,
              type: "annoucement",
            },
            { root: true }
          );
          break;
        }
        default: {
          if (msg.type.endsWith("-new-block")) {
            const projectName = msg.type.split("-")[0];
            const project = rootGetters["projectConfig/getProjectByName"](
              projectName
            );
            if (window.location.pathname.startsWith(`/stake/${projectName}`)) {
              dispatch("staking/tendermint/setBlockInfo", msg, { root: true });
              if (msg.blockHeight % project.config.refreshBlocks === 0) {
                dispatch("staking/tendermint/fetchRequiredInfo", null, {
                  root: true,
                });
                if (projectName === "osmosis") {
                  dispatch(
                    "staking/tendermint/osmosis/getAutocompoundLocks",
                    null,
                    { root: true }
                  );
                  dispatch("staking/tendermint/osmosis/getGrantStatus", null, {
                    root: true,
                  });
                }
              }
            }
          }
        }
      }
    }, 1000);
  };
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
